// import landingLayout from '@/modules/saryahLanding/components/landing-layout.vue';
// import { i18n } from '@/i18n';
import { storeAsync } from '@/app-module';
// const store = storeAsync();
import { getLanguages, setLanguageCode } from '@/i18n';
const languages = getLanguages().map(lang => lang.id)
console.log('languages : ', languages)
import i18n from '@/vueI18n'


const CustomEmailActionHandlersPage = () =>
  import('@/modules/auth/components/custom-email-action-handlers-page.vue');

export default [
  {
    name: 'customHandler',
    path: '/__/auth/custom-handler/action',
    component: CustomEmailActionHandlersPage,
    // props: true,
    meta: {
      unauth: true,
      // title: i18n('metaTitle.forgetPass')
    },
    beforeEnter: (to, from, next) => {
      document.title = to.meta.title  
      const lang = to.query.lang || 'en'; 
      setLanguageCode(lang)
      storeAsync().dispatch('saryahLanding/landing/changeCurrentLanguageCode', lang);
      i18n.locale = lang;
      next()
    }
  }, 
];